module.exports = __webpack_public_path__ + "img/partnership_03.836ee266.jpg";